import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { z } from 'zod';
import { MarginRateSchema } from '../common/margin-rate.schema';

export const ContactSchema = z.object({
  name: z.string().optional(),
  email: z
    .string()
    .email({ message: 'Email non valide' })
    .or(z.literal(''))
    .optional(),
  phoneNumber: z
    .string()
    .regex(
      /^\+?[0-9]+$/,
      'Le numéro de téléphone ne doit contenir que des chiffres ou un + au début',
    )
    .min(5, 'Le numéro de téléphone doit contenir au moins 5 caractères')
    .or(z.literal(''))
    .optional(),
});

export const SupplierSchema = z.object({
  name: z.string().min(1, { message: 'Le nom est requis' }),
  country: isValidSelectorString('Le pays est requis'),
  currency: isValidSelectorString('La devise est requise'),
  address: z.string().optional(),
  city: z.string().optional(),
  postalCode: z.coerce.string().optional(),
  contacts: z.array(ContactSchema),
  marginRate: MarginRateSchema.optional(),
});

export type SupplierFormData = z.infer<typeof SupplierSchema>;
